import { getTimezone, urlParams, wrappedPost } from "../general/utils";
import { showToast } from "@sourcewhale/core";

const KEYS = ["email", "password", "username", "server"];

export const initializeExchange = () => {
  if (urlParams.get("autoDiscoverWarn") === "1") {
    $("#infoPara").hide();
    $("#autoDiscoverPara").show();
  }

  if (urlParams.get("incorrectCreds") === "1") {
    $("#infoPara").hide();
    $("#incorrectCredentialsPara").show();
  }

  $("#exchangeSigninBtn").click(() => {
    const exchangeEmail = $("input#exchange-email").val();
    const exchangePassword = $("input#exchange-password").val();

    $(
      "#input-group-email .input-group-text span, #input-group-password .input-group-text span",
    ).text("");

    if (exchangeEmail.length > 0 && exchangePassword.length > 0) {
      const data = KEYS.reduce((ret, key) => {
        ret[key] = $(`#exchange-${key}`).val();
        return ret;
      }, {});

      data.provider = "exchange";

      data.redirect = urlParams.get("redirect");

      data.timezone = getTimezone();

      $("#exchangeSigninSpinner").show();
      $("#exchangeSigninText").removeClass("invisible");

      wrappedPost({
        url: "/api/signin/create_url",
        data: JSON.stringify(data),
        success: (res) => {
          window.location = res.url;
        },
      });
    } else {
      showToast({
        title: "Please enter an email and password",
        type: "warning",
      });
      if (exchangeEmail.length === 0) {
        $("#input-group-email .input-group-text span").text("*");
      }
      if (exchangePassword.length === 0) {
        $("#input-group-password .input-group-text span").text("*");
      }
    }
  });
};
